export default __webpack_public_path__ + "static/media/screenshot22.53a9ff8f.jpg";